import script from "./AnimatedText.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnimatedText.vue?vue&type=script&lang=ts&setup=true"

import "./AnimatedText.vue?vue&type=style&index=0&id=3ce86269&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ClementRivaille.github.io/ClementRivaille.github.io/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce86269"]])

export default __exports__